export enum ComplaintResolutionAction {
  Refund = 'refund',
  RequestToReturn = 'request_to_return',
  ChooseResolution = 'choose_resolution',
  CancelRefundOffer = 'cancel_refund_offer',
}

export enum ComplaintResolutionChoice {
  Refund = 'refund',
  RequestToReturn = 'request_to_return',
  OfferPartialRefund = 'offer_partial_refund',
}

export enum ComplaintOrderType {
  C2C = 'c2c',
  B2C = 'b2c',
  B2B = 'b2b',
  C2B = 'c2b',
}

export enum EstimatedRefundFactualShippingMethod {
  Custom = 'custom',
  Integrated = 'integrated',
}

export enum EstimatedRefundInformationModal {
  EstimatedRefund = 'estimatedRefund',
  BuyerProtectionFee = 'buyerProtectionFee',
  CurrencyConversion = 'currencyConversion',
  ItemDiscounts = 'itemDiscounts',
}

export enum RefundOfferAction {
  Accept = 'accept',
  Reject = 'reject',
  Cancel = 'cancel',
}

export enum ReturnShippingOption {
  Integrated = 'integrated',
  Custom = 'custom',
}

export enum ReturnShippingOptionPricing {
  RefundSubtotal = 'refund_subtotal',
  Postage = 'postage',
  RefundTotal = 'refund_total',
}

export enum ReturnShippingMethod {
  Custom = 'custom',
  Integrated = 'integrated',
}

export enum ReturnShippingMethodPayingSide {
  Seller = 'seller_pays',
  Buyer = 'buyer_pays',
}

export enum ReturnShippingModal {
  Checkout = 'checkout',
  RequestReturnModal = 'request_return_modal',
  GenericErrorModal = 'generic_error_modal',
  None = 'none',
}

export enum ComplaintType {
  Snad = 'snad',
  Delivery = 'delivery',
}

export const ISSUES_WITH_DELIVERY_FAQ_ID = 1517
export const ISSUES_WITH_DELIVERY_BUNDLE_FAQ_ID = 1524

export const DELIVERY_COMPLAINT_FAQ_IDS = [
  ISSUES_WITH_DELIVERY_FAQ_ID,
  ISSUES_WITH_DELIVERY_BUNDLE_FAQ_ID,
]

export enum RefundElements {
  ReturnShipping = 'return_shipping',
}

export enum RefundElementsWithAction {
  TotalItemsDiscount = 'total_items_discount',
  BuyerProtectionFee = 'bpf',
}

export enum PackageSizeCode {
  XSmall = 'X_SMALL',
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE',
  XLarge = 'X_LARGE',
  Custom = 'CUSTOM',
  NoShipping = 'NO_SHIPPING',
  HeavySmall = 'HEAVY_SMALL',
  HeavyMedium = 'HEAVY_MEDIUM',
  HeavyLarge = 'HEAVY_LARGE',
  HeavyBulkySmall = 'HEAVY_BULKY_SMALL',
  HeavyBulkyMedium = 'HEAVY_BULKY_MEDIUM',
  HeavyBulkyLarge = 'HEAVY_BULKY_LARGE',
}

export enum ApplicableTransactionAction {
  Offer = 'offer',
  Buy = 'buy',
  RequestOffer = 'request_offer',
  Transfer = 'transfer',
  Reserve = 'reserve',
  WaitingForShipment = 'waiting_for_shipment',
  LeaveFeedback = 'feedback',
}

export enum AdditionalTransactionAction {
  MarkAsSold = 'mark_as_sold',
  MarkAsReceived = 'mark_as_received',
  CanMarkAsReceived = 'can_mark_as_received',
  Bundle = 'bundle',
  UsePayments = 'use_payments',
  DeleteConversation = 'delete_thread',
  Cancel = 'cancel',
  ConfirmShipmentInstructions = 'confirm_shipment_instructions',
  ExtendShippingDeadline = 'extend_shipping_deadline',
  ChangeDeliveryOption = 'change_delivery_option',
}

export enum TransactionSide {
  Buyer = 'buyer',
  Seller = 'seller',
}

export enum UserThumbnailSize {
  Small = 'thumb20',
  Medium = 'thumb30',
  Default = 'thumb50',
  Large = 'thumb70',
  XLarge = 'thumb90',
  X2Large = 'thumb100',
  X3Large = 'thumb140',
  X4Large = 'thumb150',
  X5Large = 'thumb175',
  X6Large = 'thumb310',
}

export enum ShipmentStatus {
  New = 1,
  Estimated = 100,
  InstructionsConfirmed = 150,
  LabelProcessing = 200,
  LabelFailed = 210,
  LabelProcessed = 220,
  LabelSent = 230,
  TrackingPending = 250,
  Shipped = 300,
  HeldAtPostOffice = 310,
  LostParcel = 350,
  Delivered = 400,
  CancelDone = 500,
  ReturnToSender = 600,
  ReturnToSenderAvailableForPickup = 610,
  CancelFailed = 620,
  ReturnToSenderDelivered = 625,
  ReturnToSenderCompleted = 630,
  ShippedToFacility = 700,
  ArrivedAtFacility = 710,
  VerificationSuccessful = 720,
  VerificationFailed = 730,
  ShippedFromFacility = 740,
}

export enum PhoneRequirement {
  Disabled = 'disabled',
  Optional = 'optional',
  Mandatory = 'mandatory',
}

export enum AddressEntryType {
  None = 0,
  Shipping = 1,
  Billing = 2,
}
